import styled from 'styled-components'

export const SiteSection = styled.div`
  max-width 25rem;
  width: 100%;
  margin: 0px auto 75px;
  padding: 65px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-direction: center;
`;